import { render, staticRenderFns } from "./ProductDayLock.vue?vue&type=template&id=1392b026"
import script from "./ProductDayLock.vue?vue&type=script&lang=js"
export * from "./ProductDayLock.vue?vue&type=script&lang=js"
import style0 from "./ProductDayLock.vue?vue&type=style&index=0&id=1392b026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports